var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy-code_svg__clip0_23947_41379)",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.833 6h-6C7.097 6 6.5 6.597 6.5 7.333v6c0 .737.597 1.334 1.333 1.334h6c.737 0 1.334-.597 1.334-1.334v-6c0-.736-.597-1.333-1.334-1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.834 10h-.667a1.333 1.333 0 01-1.333-1.333v-6a1.333 1.333 0 011.333-1.333h6a1.333 1.333 0 011.334 1.333v.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy-code_svg__clip0_23947_41379"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/copy-code.a389d6ba.svg";
export { SvgCopyCode as ReactComponent };